import axios from "axios";

// export default axios.create({
//   baseURL: "http://localhost:4000",
// });

const JSON_API = axios.create({
  baseURL: "https://hommer-dev.altaqnya.com.ly",
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
});


// Add a request interceptor
JSON_API.interceptors.request.use(
  function (config) {
    // Retrieve the token from localStorage
    const token = localStorage.getItem("jwt");

    // Check if the current path is the login page
    const currentPath = window.location.pathname;
    const currentQueryParams = window.location.search;
    const isLoginPage = currentPath === '/login';

    if (token) {
      // If the token exists, set the Authorization header
      config.headers["Authorization"] = 'Bearer ' + token;
    } else if (!isLoginPage) {
      // If no token is found and the current page is not the login page, redirect to the login page
      window.location.href = `/login?redirect=${encodeURIComponent(currentPath + currentQueryParams)}`;

      // Prevent the request from proceeding by rejecting it with an error
      return Promise.reject(new Error("No token present, redirecting to login."));
    }

    return config;
  },
  function (error) {
    // Handle request error
    return Promise.reject(new Response(true, "إنتهت صلاحية الجلسة", error, 401));
  }
);
// Add a response interceptor
JSON_API.interceptors.response.use(
  response => {
    // If the response is successful, simply return it
    return response;
  },
  error => {
    // Check if the response status is 401 or 304
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Get the current path and query parameters
      const currentPath = window.location.pathname;
      const currentQueryParams = window.location.search;

      const isLoginPage = currentPath === '/login';
      if (!isLoginPage) {
        // If no token is found and the current page is not the login page, redirect to the login page
        window.location.href = `/login?redirect=${encodeURIComponent(currentPath + currentQueryParams)}`;

        // Prevent the request from proceeding by rejecting it with an error
        return Promise.reject(new Error("No token present, redirecting to login."));
      }
    }

    // Return the error to allow further handling if needed
    return Promise.reject(error);
  }
);
export default JSON_API;
